<script setup>
import { onMounted, watch } from 'vue';
import { useOnboarding } from './useOnboarding';

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});

const { shouldShowTour, startTour } = useOnboarding();

watch(
  () => props.active,
  isActive => {
    if (isActive && shouldShowTour.value) {
      startTour();
    }
  }
);

onMounted(() => {
  if (props.active && shouldShowTour.value) {
    startTour();
  }
});
</script>

<template>
  <div data-testid="onboarding-tour" />
</template>
